<div class="buttons-container">
  <ul class="buttons-container__list">
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="refreshWorkItem()" [disabled]="!isDataAvailable">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="exportToExcel()" [disabled]="!isDataAvailable">
        <mat-icon>insert_drive_file</mat-icon>
        Export to Excel
      </button>
    </li> 
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="setDropDown(adminEmitter.reAssign, $event)" [disabled]="reAssignDisable()">
        <mat-icon>account_circle</mat-icon>
        Re-Assign
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="assignReleaseWorkItem('RELEASE')" [disabled]="releaseDisable()">
        <mat-icon>lock_open_right</mat-icon>
        Release
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="downloadWorkItem()" [disabled]="printDisable()">
        <mat-icon>download</mat-icon>
        Print/Save
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button short-button" (click)="showEmailModal()" [disabled]="emailDisable()">
        <mat-icon>email</mat-icon>
        Email
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button short-button" (click)="copyLink()" [disabled]="linkDisable()">
        <mat-icon>link</mat-icon>
        Link
      </button>
    </li> 
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showLineItemsGLEntry()"
        [disabled]="documentHistoryDisable()">
        <mat-icon>description</mat-icon>
        View Line Item / GL Entry
      </button>
    </li> 
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewHistory()" [disabled]="workflowHistoryDisable()">
        <mat-icon>history</mat-icon>
        View Workflow History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentHistory()" [disabled]="documentHistoryDisable()">
        <mat-icon>history</mat-icon>
        View Document History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewNotes()" [disabled]="workflowNotesDisable()">
        <mat-icon>group_work</mat-icon>
        View / Add Workflow Notes
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentNotesAdmin()" [disabled]="documentNotesDisable()">
        <mat-icon>description</mat-icon>
        View Document Notes
      </button>
    </li> 
  </ul>
</div>
<div class="row" style="padding: 20px;">
  <div class="data-not-found" *ngIf="!isDataAvailable">
    Data not available
  </div>
  <div>
    <p-table  *ngIf="isDataAvailable"
    [columns]="columns" 
    [value]="workItems"  
    [rows]="25" 
    [paginator]="true" 
    [(selection)]="selectedWorkItems"
    [sortField]="sortField" 
    [sortOrder]="sortOrder"
    (onColReorder)="onColumnReordered($event)"
    [reorderableColumns]="true" 
    sortMode="multiple"
    [loading]="isTableLoading" 
    [loadingIcon]="''" 
    [resizableColumns]="true"
    columnResizeMode="expand"> 
      <ng-template pTemplate="header" let-columns> 
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col">
            <div class="top-div">
              <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
              <div class="spacer"><p-sortIcon [field]="col.field" /></div>
              <div> 
                <p-columnFilter class="icon-section" [ngClass]="{'active': col.advancefilter.isAdvanceFilterUsed}" #filterRef [type]="col.type" [field]="col.field" display="menu" [showMatchModes]="false" [showOperator]="false"
                      [filterModel]="col.advancefilter"> 
                  <ng-template
                    pTemplate="filter"
                    let-values
                    let-filter="filterCallback"
                    let-index="index">

                    <div class="rules-holder" *ngFor="let constraint of col.advancefilter!.constraints; let i = index" >
                      <p *ngIf="i === 0">Show items with value that:</p>
                      <p-dropdown
                        class="p-dropdown"
                        [options]="col.advancefilter!.matchModeOptions" [(ngModel)]="constraint.matchMode" optionLabel="label"
                        optionValue="value"
                        (change)="onMatchModeChange($event, col.field, i)"/> 
                
                      <input *ngIf="col.type == 'string' || col.type == 'number'"
                        type="text"
                        pInputText
                        class="p-inputtext"
                        [value]="constraint.value"
                        (input)="onRuleChange($event, col.field, i)"/> 

                      <p-calendar class="p-calendar"
                      *ngIf="col.type == 'date'"
                      [(ngModel)]="constraint.value"
                      (onSelect)="onDateRuleChange($event, col.field, i)"
                      [showTime]="true"
                      [hourFormat]="'12'"
                      [showIcon]="true"
                      [placeholder]="'Select date and time'"></p-calendar>
                        
                      <div class="operator" *ngIf="i === 0" > 
                        <p-dropdown 
                          [options]="[
                            { label: 'And', value: 'and' },
                            { label: 'Or', value: 'or' }
                          ]"
                          [(ngModel)]="col.advancefilter.operator"
                          (onChange)="onOperatorChange($event, col.field)"
                          class="p-dropdown" >
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="p-d-flex p-jc-end p-ai-center p-gap-2">
                      <button pButton type="button" label="Apply" 
                        class="p-button-primary p-button-sm"
                        (click)="applyCall(col, filter, filterRef)">
                      </button>
                      <button pButton type="button" label="Clear" 
                        class="p-button-secondary p-button-sm"
                        (click)="clearCall(col, filter, filterRef)">
                      </button>
                    </div>
                  </ng-template> 
                </p-columnFilter>
              </div>
            </div>
            <div class="bottom-div">
              <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false" (onClear)="customClear(col)" >
                <ng-template pTemplate="filter" >
                  <p-multiSelect 
                  [options]="col.filterOptions" 
                  placeholder="Select" 
                  (onChange)="customFilter(col.type)" 
                  [(ngModel)]="filters[col.field]" 
                  [optionLabel]="'label'"
                  appendTo="body"  
                  [panelStyle]="{'z-index': '1000'}">
                      <ng-template let-option pTemplate="item">
                          <div class="inline-block vertical-align-middle">
                              <span class="ml-1 mt-1">{{ option['label'] }}</span>
                          </div> 
                      </ng-template>
                  </p-multiSelect> 
                </ng-template> 
              </p-columnFilter>  
              <button class="clear-button" mat-icon-button
                  *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" 
                  (click)="customClear(col)" >
                <mat-icon class="clear-button-icon" >close</mat-icon>
              </button> 
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-index="rowIndex">
        <tr [pSelectableRow]="rowData" [class.selected-row]="selected"
          [ngClass]="{ 'p-highlight': isSelected( index) }" (click)="onRowClick($event, index)" (keydown)="onRowKeydown($event, index)" (focus)="onRowFocus($event, index)"
          (mousedown)="onMouseDown($event, index)" (mouseover)="onMouseOver($event, index)"
          (mouseup)="onMouseUp($event)">
          <td *ngFor="let col of columns" (dblclick)="copyToClipboard(rowData[col.field])">
            <ng-container *ngIf="col.field == 'InstanceId'; else textContent">
              <a (click)="openDocument(rowData['view_Document'], $event)" (contextmenu)="handleRightClick($event)">{{ rowData[col.field] }}</a>
            </ng-container>
            <ng-template #textContent>
              {{ rowData[col.field] }}
            </ng-template>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
        <div class="custom-paginator-text">
          {{ state.first + 1 }} - {{ min(state.first + state.rows, state.totalRecords) }} of {{ state.totalRecords }} items
        </div>
      </ng-template>
    </p-table>
  </div>
</div>